import { FullscreenExit, OpenInFull } from '@mui/icons-material';
import styles from './RegionThumbnailCard.module.css';
import { BrazilMapSVG } from '../../Map/BrazilMap/BrazilMapSVG';

interface RegionThumbnailCardProps {
	id: string;
	name: string;
	stateCodes: string[];
	isSelected?: boolean;
	isExpanded?: boolean;
	showExpandIcon?: boolean;
	onClick: () => void;
	onExpand?: (e: React.MouseEvent) => void;
}

export const RegionThumbnailCard = ({
	name,
	stateCodes,
	isSelected = false,
	isExpanded = false,
	showExpandIcon = false,
	onClick,
	onExpand,
}: RegionThumbnailCardProps) => {
	return (
		<div
			className={`${styles.card}`}
			onClick={onClick}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
			aria-pressed={isSelected}
		>
			<div
				className={`${styles.mapContainer} ${isSelected ? styles.selected : ''} ${isExpanded ? styles.expanded : ''}`}
			>
				{showExpandIcon && onExpand && (
					<button
						className={styles.expandBtn}
						onClick={(e) => { e.stopPropagation(); onExpand(e); }}
						aria-label={isExpanded ? 'Recolher' : 'Expandir'}
					>
						{isExpanded ? (
							<FullscreenExit sx={{ fontSize: '1.25rem' }} />
						) : (
							<OpenInFull sx={{ fontSize: '1.25rem' }} />
						)}
					</button>
				)}
				<div className={`${styles.mapWrapper} ${isExpanded ? styles.mapExpanded : ''}`}>
					<BrazilMapSVG selectedStateCodes={stateCodes} />
				</div>
			</div>
			<span className={styles.label}>{name}</span>
		</div>
	);
};
